import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import SectionHead from "../components/SectionHead";
import AreaMap from "../components/AreaMap";
import { Reveal } from "../components/motion";
import { MUNICIPIOS } from "../data/content";
import { useLang } from "../i18n";

const AreaPage = () => {
    const { t } = useLang();
    const a = t.areaPage;

    return (
        <main className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-24">
            <SectionHead
                eyebrow={a.eyebrow}
                title={a.title}
                sub={a.sub}
                testid="area-page-title"
            />

            <Reveal delay={0.1} className="mt-12">
                <AreaMap />
            </Reveal>

            <div className="mt-16 grid gap-10 lg:grid-cols-12">
                <div className="space-y-5 text-base leading-relaxed text-[#525B53] lg:col-span-7">
                    <Reveal>
                        <h2 className="font-serif text-2xl font-semibold text-ink sm:text-3xl">
                            {a.h2}
                        </h2>
                        <p className="mt-4">{a.p1}</p>
                        <p>
                            {a.p2a} <strong className="font-semibold text-ink">{a.p2b}</strong>, {a.p2c}{" "}
                            <strong className="font-semibold text-ink">{a.p2d}</strong> {a.p2e}{" "}
                            <strong className="font-semibold text-ink">{a.p2f}</strong>, {a.p2g}
                        </p>
                    </Reveal>
                </div>

                <Reveal delay={0.1} className="lg:col-span-5">
                    <div className="rounded-[1.5rem] border border-[#E3DCCF] bg-white p-7">
                        <h2 className="font-serif text-xl font-semibold text-ink">{a.municipiosTitle}</h2>
                        <ul className="mt-4 grid grid-cols-1 gap-2.5">
                            {MUNICIPIOS.map((m) => (
                                <li key={m} className="flex items-center gap-2.5 text-sm text-[#525B53]">
                                    <MapPin size={14} className="shrink-0 text-terracotta" />
                                    {a.line1} <strong className="font-semibold text-ink">{m}</strong>
                                </li>
                            ))}
                        </ul>
                        <p className="mt-4 text-xs leading-relaxed text-[#7C877E]">
                            {a.other}
                        </p>
                    </div>
                </Reveal>
            </div>

            <Reveal className="mt-16 rounded-[2rem] bg-olive p-10 text-center text-cream sm:p-14">
                <h2 className="font-serif text-2xl font-semibold sm:text-3xl">
                    {a.ctaTitle}
                </h2>
                <p className="mx-auto mt-3 max-w-xl text-[15px] leading-relaxed text-cream/80">
                    {a.ctaSub}
                </p>
                <Link
                    to="/contacto"
                    data-testid="area-page-cta"
                    className="mt-7 inline-flex rounded-full bg-terracotta px-8 py-4 text-[15px] font-bold text-cream shadow-lg transition-[background-color,transform] duration-200 hover:bg-terracotta-dark hover:-translate-y-0.5"
                >
                    {a.cta}
                </Link>
            </Reveal>
        </main>
    );
};

export default AreaPage;
